export default {
  PUBLIC_SEARCH: {
    SELECT_ALL: 'All',
    TITLE: 'Find your next job',
    SUBTITLE: 'Thousands of job offers are waiting for you',
    META: { TITLE: 'Search job offers' },
    TABS: {
      OFFERS: 'Job offers',
      OFFERS_SHORT: 'Offers',
      COMPANIES: 'Companies',
    },
    OFFERS: {
      SEARCH_PLACEHOLDER: 'Job title, company or city...',
      SEARCH_BTN: 'Search',
      RESULTS_COUNT: 'offers found',
      NO_RESULTS: 'No offers found',
      NO_RESULTS_HINT: 'Try different filters or search terms.',
      NO_RESULTS_COMPANY_TITLE: 'Company with no active offers',
      NO_RESULTS_COMPANY_HINT: 'This company doesn\'t have any active offers right now.\nSearch for another company or explore other offers that might interest you.',
      FILTERS: {
        COMPANY: 'Companies',
        TYPE: 'Type',
        CONTRACT_TYPE: 'Contract type',
        WORKING_DAY: 'Working hours',
        COUNTRY: 'Country',
        CITY: 'City / Population',
        PUBLISHED_WITHIN: 'Publication date',
        PUBLISHED_24H: 'Last 24 hours',
        PUBLISHED_3D: 'Last 3 days',
        PUBLISHED_7D: 'Last 7 days',
        PUBLISHED_15D: 'Last 15 days',
        PUBLISHED_1M: 'Last month',
        CLEAR: 'Clear filters',
      },
      SORT: {
        PLACEHOLDER: 'Sort by...',
        PLACEHOLDER_SHORT: 'Sort...',
        RECENT: 'Recent',
        RELEVANT: 'More enrolled',
        RELEVANT_TOOLTIP: 'Offers with the highest number of enrolled candidates',
        SALARY: 'Highest salary',
        ALPHABETICAL: 'Name A-Z',
      },
      DOWNLOAD_APP_TEXT: 'These are just some of the available offers.\nDownload the wokap app to see them all.',
      CARD: { PUBLISHED: 'Published at', WATCH_VIDEO: 'Watch offer video', PREVIEW: 'Quick preview', APPLY: 'Apply for this offer' },
    },
    COMPANIES: {
      SEARCH_PLACEHOLDER: 'Company name...',
      SEARCH_BTN: 'Search',
      RESULTS_COUNT: 'companies found',
      NO_RESULTS: 'No companies found',
      NO_RESULTS_HINT: 'Try different filters or search terms.',
      FILTERS: {
        COUNTRY: 'Country',
        SECTOR: 'Sector',
        SIZE: 'Size',
        HAS_ACTIVE_OFFERS_TITLE: 'Active Offers',
        HAS_ACTIVE_OFFERS: 'With active offers',
        CITY: 'City / Population',
        CLEAR: 'Clear filters',
      },
      SORT: {
        PLACEHOLDER: 'Sort by...',
        PLACEHOLDER_SHORT: 'Sort...',
        RECENT: 'Recently posted',
        MORE_OFFERS: 'More # of offers',
        ALPHABETICAL: 'Name A-Z',
      },
      SIZES: {
        MICRO: '1-9 employees',
        SMALL: '10-49 employees',
        MEDIUM: '50-249 employees',
        LARGE: '250+ employees',
      },
      DOWNLOAD_APP_TEXT: 'These are just some of the companies using wokap.\nDownload the app to get to know them all.',
      DOWNLOAD_APP_TEXT_MOBILE: 'These are some companies using wokap.\nDownload the app to get to know them all.',
      CARD: {
        ACTIVE_OFFERS: 'active offer(s)',
        NO_OFFERS: 'No active offers',
      },
    },
    GEO: {
      USE_LOCATION: 'Use my location',
      ACTIVE: 'Location active',
      CLEAR: 'Remove location',
      DISTANCE: 'Search radius',
      ANY_DISTANCE: 'Distance',
      LOCATION_DENIED: 'Location permission denied',
      LOCATION: 'Location',
    },
    FILTER_BTN: 'Filter',
    FILTER_BTN_COUNT_SINGULAR: '1 Filter applied',
    FILTER_BTN_COUNT_PLURAL: '{{count}} Filters applied',
    FILTER_OFFERS: 'Filter offers',
    FILTER_COMPANIES: 'Filter companies',
    SHOW_RESULTS: 'Show results',
    APPLY_FILTERS: 'Apply filters',
    APPLY: 'Apply',
    CLEAR_FILTERS: 'Clear filters',
    CLEAR_ALL: 'Clear all',
    CLEAR_FILTER: 'Clear',
    SEARCH_COUNTRY: 'Search country…',
    SEARCH_CITY: 'Search city / population…',
    SEARCH_SECTOR: 'Search sector…',
    SEARCH_COMPANY: 'Search company…',
    LOADING: 'Searching…',
    HEADER: { SEARCH_JOBS: 'Are you a company?', DOWNLOAD_APP: 'Download app' },
  },
} as const;
